<template>
  <v-row class="align-start">
    <v-col cols="6" md="1">
      <img :src="item.product.image.url" width="100%" alt="">
    </v-col>
    <v-col cols="6" md="2">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">{{ i18n["product_name"] }}</div>
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;">{{item.product.name_ar}}</div>
    </v-col>
    <v-col cols="6" md="1">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">Code</div>
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;">{{item.product.sku}}</div>
    </v-col>
    <v-col cols="6" md="1" v-if="master">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">{{ i18n["price"] }}</div>
      <div :class="`${arabic?'arFont':'enFont'}`">{{item.price}} {{lead.currency_symbol}}</div>
    </v-col>
    <v-col cols="6" md="1" v-if="master">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">{{ i18n["profit"] }}</div>
      <div :class="`${arabic?'arFont':'enFont'}`">{{item.user_profit}} {{lead.currency_symbol}}</div>
    </v-col>
    <v-col cols="6" md="1">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">{{ i18n['quantity'] }}</div>
      <div :class="`${arabic?'arFont':'enFont'}`">{{item.quantity}}</div>
    </v-col>
    <v-col cols="6" :md="`${master? '1': '4'}`">
      <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:10px;font-weight:bold;">{{i18n["total"]}}</div>
      <div :class="`${arabic?'arFont':'enFont'}`">{{item.total}} {{lead.currency_symbol}}</div>
    </v-col>
    <v-col cols="6" md="2" class="text-left" v-if="master">
      <div :class="`${arabic?'arFont':'enFont'} success--text`" style="font-size:10px;font-weight:bold;">{{ i18n["total_profit"] }}</div>
      <div :class="`${arabic?'arFont':'enFont'} success--text`">{{item.total_profit}} {{lead.currency_symbol}}</div>
    </v-col>
    <v-col cols="6" md="2" class="text-left" v-if="master">
      <div :class="`${arabic?'arFont':'enFont'} success--text`" style="font-size:10px;font-weight:bold;">{{ i18n["total_profit_in_usd"] }}</div>
      <div :class="`${arabic?'arFont':'enFont'} success--text`">${{item.base_total_profit}}</div>
    </v-col>
    <v-col cols="12" class="py-0 my-0">
      <v-divider></v-divider>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:['lead', 'item'],
  data(){
    return {
      dialog:true,
    }
  },
  computed:{
    master(){
      return this.user.role == 'master'
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>